import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs/index';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AutoremindService } from '../services/autoremind.service';
import { Ar2UserActions } from './ar2-user-actions.service';

@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable - but must still register effects
})
export class Ar2UserEffect {
    constructor(
        private actions$: Actions,
        private autoremindService: AutoremindService) {
    }

    getTemplatesAndNotificationOffsets$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(Ar2UserActions.getTemplatesAndNotificationOffsets),
            switchMap(action =>
                this.autoremindService.getTemplatesAndNotificationOffsetsForAR2User()
                    .pipe(
                        map((payload: any) =>
                            Ar2UserActions.getTemplatesAndNotificationOffsetsSuccess({ payload})
                        ),
                        catchError(error =>
                            of(Ar2UserActions.getTemplatesAndNotificationOffsetsFail({ error }))
                        )
                    )
            )
        )
    );

}
